module.exports = __webpack_public_path__ + "img/logoW.32e9e8ba.png";